export const CHECK_STATUS = [
  {
    title: '全部',
    val: '全部',
  },
  {
    title: '待审核',
    val: 0,
  },
  {
    title: '已驳回',
    val: 3,
  },
  {
    title: '已通过',
    val: 2,
  },
  // {
  //     title: '修改待审核',
  //     val: 4
  // }
];
export const SYNC_STATUS = [
  {
    title: '全部',
    val: '全部',
  },
  {
    title: '未同步',
    val: 0,
  },
  {
    title: '同步成功',
    val: 2,
  },
  {
    title: '同步失败',
    val: 3,
  },
  {
    title: '已失效',
    val: 4,
  },
];
